import { Chip, Grid, styled, useTheme } from "@mui/material"
import { Column } from "@tanstack/react-table"
import { FC } from "react"
import { SelectedFiltersProps } from "../tableProps.interface"
import { useTranslation } from "react-i18next"

const SelectedFilters: FC<SelectedFiltersProps> = ({ table, setFiltering }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const StyledFilterChip = styled(Chip)(({ theme }) => ({
    border: 0,
    color: (theme.palette as any).default[600],
    backgroundColor: (theme.palette as any).secondary[200],
    "& .MuiChip-deleteIcon": {
      color: (theme.palette as any).secondary[300]
    },
    "&:hover .MuiChip-deleteIcon": {
      color: (theme.palette as any).secondary[400],
    }
  }))

  return (
    <Grid container direction="row" spacing={1} mt={1}>
      {table
        .getAllColumns()
        .filter((column: Column<any>) => column.getFilterValue() !== undefined)
        .map((column: Column<any>) => {
          const filterValue = column.getFilterValue()
          if (filterValue === undefined) return null

          const values = Array.isArray(filterValue) ? Object.values(filterValue) : []
          if (Array.isArray(filterValue) && values.length === 0) return null

          return Array.isArray(filterValue) ? (
            values.map((value: string | number, filterIndex: number) => {
              const displayName =
                column.columnDef.meta?.filterOptions?.find((opt) => opt.value === value)?.name ?? value

              return (
                <Grid item key={`${column.id}-${value}`}>
                  <StyledFilterChip
                    label={`${column?.columnDef?.header}: ${displayName}`}
                    onDelete={() => {
                      const updated = values.filter((_, i) => i !== filterIndex)
                      column.setFilterValue(updated.length > 0 ? updated : undefined)
                    }}
                  />
                </Grid>
              )
            })
          ) : (
            <Grid item key={`${column.id}-${filterValue}`}>
              <StyledFilterChip
                label={`${column?.columnDef?.header}: ${filterValue}`}
                onDelete={() => {
                  column.setFilterValue(undefined)
                }}
              />
            </Grid>
          )
        })}

      {table.getAllColumns().filter((column: Column<any>) => column.getFilterValue() !== undefined).length >
        0 && (
          <Grid item>
            <Chip style={{ border: 0, color: (theme.palette as any).default[600] }} variant="outlined" label={t("global.clear", "Clear")} onClick={() => setFiltering([])} />{" "}
          </Grid>
        )}
    </Grid>
  )
}

export default SelectedFilters
